import styled from 'styled-components';
import { cssVariables } from 'styles/root';

export const StyledResetPassword = styled.div`
  display: block;
  align-items: flex-start;
  margin: 0 auto;
  padding-top: 120px;
  flex-direction: column;
  max-width: 472px;
`;

export const StyledHeaderTitle = styled.div`
  margin-bottom: 40px;
`;

export const StyledResetPasswordFields = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  &label {
    font-weight: ${cssVariables.font.normal};
  }
`;

export const StyledResetPasswordBottomLinks = styled.div`
  display: block;
  text-align: center;
  margin-top: 20px;

  a {
    margin: 0 20px;
  }
`;

export const StyledForm = styled.form`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;
